// extracted by mini-css-extract-plugin
export default {"primaryButton":"primarybutton_primaryButton__k-maQ"};